<template>
  <el-dialog
    top="10vh"
    :title="$t('Common.detail')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <Description>
      <DescriptionItem :span="24" :label="$t('Product.productCategory')">{{
        info.categoryName | format
      }}</DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Product.serialName')">{{
        info.name | format
      }}</DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Product.serialCode')">{{
        info.code | format
      }}</DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Common.createTime')">{{
        info.createTime | formatTime
      }}</DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Common.updateTime')">{{
        info.updateTime | formatTime
      }}</DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Common.remark')">{{
        info.remarks | format
      }}</DescriptionItem>
    </Description>
  </el-dialog>
</template>

<script>
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'

import { format, formatTime } from '@/utils/utils'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  components: {
    Description,
    DescriptionItem
  },
  data() {
    return {
      info: {}
    }
  },
  created() {
    if (this.row.id) {
      this.getDetail()
    }
  },
  filters: {
    format(val) {
      return format(val)
    },
    formatTime(val) {
      return formatTime(val)
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    getDetail() {
      const params = {
        id: this.row.id
      }
      this.$ajax
        .get(this.$api.product.series_detail, params)
        .then((res) => {
          if (res.data) {
            this.info = res.data
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss"></style>
